import React, { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import MainContent from "./MainContent";

const Layout = ({ username }) => {
  const [activeTab, setActiveTab] = useState("orders");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isAnyModalActive, setIsAnyModalActive] = useState(false);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (isSidebarOpen) {
      setIsSidebarOpen(false);
    }
  };

  const handleHamburgerClick = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="layout">
      <Header
        username={username}
        handleHamburgerClick={handleHamburgerClick}
        isSidebarOpen={isSidebarOpen}
      />
      <div className="layout-container">
        {!isAnyModalActive && (
          <Sidebar
            activeTab={activeTab}
            handleTabClick={handleTabClick}
            isSidebarOpen={isSidebarOpen}
          />
        )}
        <MainContent
          activeTab={activeTab}
          setIsAnyModalActive={setIsAnyModalActive}
          isAnyModalActive={isAnyModalActive}
        />
      </div>
    </div>
  );
};

export default Layout;
